import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineShoppingBag } from 'react-icons/hi';
import toast from 'react-hot-toast';
import { ProductContext } from '../context/ProductContext';

function Cart() {
  const { cartItem, updateQuantity, removeCartItem } = useContext(ProductContext);

  const handlePurchase = () => {
    toast.success('Purchase feature is under development!');
  };

  const removeItem = (id) => {
    removeCartItem(id);
    toast.success('Item removed from cart');
  };

  const subtotal = cartItem.reduce((total, item) => total + item.price * item.quantity, 0);

  if (cartItem.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-gray-300 py-20 text-center">
        <HiOutlineShoppingBag size={48} className="text-gray-300" />
        <h2 className="text-xl font-bold text-gray-900">Your cart is empty</h2>
        <p className="text-gray-500">Looks like you haven't added anything to your cart yet.</p>
        <Link to="/" className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700">
          Continue shopping
        </Link>
      </div>
    );
  }

  return (
    <div>
      <h2 className="mb-6 text-xl font-bold text-gray-900">Your Shopping Cart ({cartItem.length})</h2>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="space-y-4 lg:col-span-2">
          {cartItem.map((item) => (
            <div key={item.id} className="flex gap-4 rounded-xl border border-gray-200 bg-white p-4">
              <img src={item.thumbnail} alt={item.title} className="h-20 w-20 shrink-0 rounded-lg object-cover" />
              <div className="flex flex-1 flex-col justify-between">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <Link to={`/product/${item.id}`} className="text-sm font-semibold text-gray-900 hover:text-brand-700">
                      {item.title}
                    </Link>
                    <p className="text-sm text-gray-500">${item.price.toFixed(2)}</p>
                  </div>
                  <button onClick={() => removeItem(item.id)} className="text-xs font-medium text-rose-600 hover:underline">
                    Remove
                  </button>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center rounded-lg border border-gray-300">
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      className="px-2.5 py-1 text-gray-600 hover:bg-gray-50"
                    >
                      -
                    </button>
                    <span className="w-8 text-center text-sm font-medium">{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      className="px-2.5 py-1 text-gray-600 hover:bg-gray-50"
                    >
                      +
                    </button>
                  </div>
                  <span className="text-sm font-semibold text-gray-900">${(item.price * item.quantity).toFixed(2)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="h-fit rounded-xl border border-gray-200 bg-white p-5">
          <h3 className="mb-4 text-base font-bold text-gray-900">Order Summary</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span>Shipping</span>
              <span>Free</span>
            </div>
            <hr className="my-2 border-gray-100" />
            <div className="flex justify-between text-base font-bold text-gray-900">
              <span>Total</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
          </div>
          <button
            onClick={handlePurchase}
            className="mt-4 w-full rounded-lg bg-brand-600 py-2.5 text-sm font-semibold text-white hover:bg-brand-700"
          >
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cart;
